function deliveyTimeChange(deliveryTime){
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        "shipandco-配達希望時間帯": deliveryTime
      }
    })
  })
}

$(document).ready(function() {
  $(document).on("change", "#drawer-time", function() {
    deliveyTimeChange($(this).val())
    $("#desktop-time").val($(this).val())
    $("#mobile-time").val($(this).val())
  });
  $(document).on("change", "#desktop-time", function() {
    deliveyTimeChange($(this).val())
    $("#drawer-time").val($(this).val())
    $("#mobile-time").val($(this).val())
  });
  $(document).on("change", "#mobile-time", function() {
    deliveyTimeChange($(this).val())
    $("#desktop-time").val($(this).val())
    $("#drawer-time").val($(this).val())
  });
});